import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { AppProps } from "./types";

const AppSettings = lazy(() =>
  import("./Settings").then(m => ({ default: m.AppSettings })),
);

export const details = {
  name: "App",
  description: "Customizable bookmark widget",
  tags: ["Organization"],
  category: "Widget",
  grid: { default: [1, 1] },
  setup: AppSettings,
  onAdd: function AppOnAdd({
    id,
    onOpenChange,
    ...props
  }: {
    onOpenChange: (value: boolean) => void;
  } & AppProps) {
    return (
      <AppSettings isNew open onOpenChange={onOpenChange} id={id} {...props} />
    );
  },
  defaultProps: {
    image: "",
    address: "",
    name: "",
  },
} as ElementDetails<AppProps>;
